export const getInitials = (name: string): string =>
	name
		.split(" ")
		.map((word) => word.charAt(0).toUpperCase())
		.join("");

export const formatEnum = (enumValue: string): string =>
	enumValue
		.toLowerCase()
		.replace(/_/g, " ")
		.replace(/\b\w/g, (char) => char.toUpperCase());

export const truncateToken = (token: string): string | undefined => {
	if (typeof token !== "string") return;
	if (token.length > 24) {
		return `${token.slice(0, 10)}...${token.slice(-9)}`;
	}
	return token.toUpperCase();
};

export const truncateAt = (
	value: string,
	maxLength: number,
): string | undefined => {
	if (typeof value !== "string") return;

	if (value.length > maxLength) {
		return `${value.slice(0, maxLength)}...`;
	}

	return value;
};

export const formatSortCode = (sortCode: string): string =>
	sortCode.replace(/(\d{2})(\d{2})(\d{2})/, "$1-$2-$3") || "";

export const formatCamelCase = (str: string) => {
	const withSpaces = str.replace(/([A-Z])/g, " $1").toLowerCase();
	return withSpaces.charAt(0).toUpperCase() + withSpaces.slice(1);
};

export const toTitleCase = (str: string) =>
	str.replace(/\b\w/g, (char: string) => char.toUpperCase());
